// src/useCustomCompareEffect.ts
import { useEffect } from "react";

// src/useCustomCompareMemoize.ts
import { useRef } from "react";
function isPrimitive(val) {
  return val == null || /^[sbn]/.test(typeof val);
}
function checkDeps(deps, depsAreEqual, name) {
  const reactHookName = `React.${name.replace(/CustomCompare/, "")}`;
  if (!(deps instanceof Array) || deps.length === 0) {
    console.warn(
      `${name} should not be used with no dependencies. Use ${reactHookName} instead.`
    );
  }
  if (deps.every(isPrimitive)) {
    console.warn(
      `${name} should not be used with dependencies that are all primitive values. Use ${reactHookName} instead.`
    );
  }
  if (typeof depsAreEqual !== "function") {
    console.warn(
      `${name} should be used with depsEqual callback for comparing deps list`
    );
  }
}
function useCustomCompareMemoize(deps, depsAreEqual) {
  const ref = useRef(void 0);
  const prevRef = useRef(
    ref.current
  );
  if (prevRef.current === void 0 || !depsAreEqual(prevRef.current, deps)) {
    ref.current = deps;
  }
  prevRef.current = deps;
  return ref.current;
}

// src/useCustomCompareEffect.ts
function useCustomCompareEffect(effect, deps, depsAreEqual) {
  if (process.env.NODE_ENV !== "production") {
    checkDeps(deps, depsAreEqual, "useCustomCompareEffect");
  }
  useEffect(effect, useCustomCompareMemoize(deps, depsAreEqual));
}
var useCustomCompareEffect_default = useCustomCompareEffect;

// src/useCustomCompareLayoutEffect.ts
import { useLayoutEffect } from "react";
function useCustomCompareLayoutEffect(effect, deps, depsAreEqual) {
  if (process.env.NODE_ENV !== "production") {
    checkDeps(deps, depsAreEqual, "useCustomCompareLayoutEffect");
  }
  useLayoutEffect(effect, useCustomCompareMemoize(deps, depsAreEqual));
}
var useCustomCompareLayoutEffect_default = useCustomCompareLayoutEffect;

// src/useCustomCompareCallback.ts
import { useCallback } from "react";
function useCustomCompareCallback(callback, deps, depsEqual) {
  if (process.env.NODE_ENV !== "production") {
    checkDeps(deps, depsEqual, "useCustomCompareCallback");
  }
  return useCallback(callback, useCustomCompareMemoize(deps, depsEqual));
}
var useCustomCompareCallback_default = useCustomCompareCallback;

// src/useCustomCompareMemo.ts
import { useMemo } from "react";
function useCustomCompareMemo(factory, deps, depsAreEqual) {
  if (process.env.NODE_ENV !== "production") {
    checkDeps(deps, depsAreEqual, "useCustomCompareMemo");
  }
  return useMemo(factory, useCustomCompareMemoize(deps, depsAreEqual));
}
var useCustomCompareMemo_default = useCustomCompareMemo;
export {
  useCustomCompareCallback_default as useCustomCompareCallback,
  useCustomCompareEffect_default as useCustomCompareEffect,
  useCustomCompareLayoutEffect_default as useCustomCompareLayoutEffect,
  useCustomCompareMemo_default as useCustomCompareMemo
};
//# sourceMappingURL=index.mjs.map